import { render, staticRenderFns } from "./ResultsGuaranteeNotice.vue?vue&type=template&id=f76575b4&"
import script from "./ResultsGuaranteeNotice.vue?vue&type=script&lang=ts&"
export * from "./ResultsGuaranteeNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports